import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {SpinButtonView} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonView';
import {SpinButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonViewEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';

export class SpinButtonBasicState extends ModuleState<SpinButtonView, SpinButtonModule> {
	protected _isTryingToRunSpinBySpaceButton: boolean = false;

	public onEnterState(): void {
		this._isTryingToRunSpinBySpaceButton = false;
	}

	public onLeaveState(): void {}

	protected setupEvents(): void {
		this.on(SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onStartAutoPlayButtonPressed);
		this.on(SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinStarted);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceButtonClicked);

		this.on(StartScreenEvents.EXIT_FINISHED, this.onIntroFinished);
	}

	protected onIntroFinished(): void {
		this.view.showSpinButton();
	}

	protected onSpaceButtonClicked(): void {
		this._isTryingToRunSpinBySpaceButton = true;
		if (this.module.validateSpaceSpinPress()) {
			this.proceedWithSpin();
		}
	}

	protected onStartAutoPlayButtonPressed(): void {
		if (this.module.validateAutoplaySpinPress()) {
			this.trySpinIfEnoughMoneyElseEmitNotEnough();
		}
	}

	protected onSpinButtonClicked(): void {
		this._isTryingToRunSpinBySpaceButton = false;
		this.proceedWithSpin();
	}

	protected proceedWithSpin(): void {
		if (this.module.hasSpinTimeRegulation()) {
			if (this.module.regulationCanSpin) {
				if (this.module.validateSpinPress()) {
					this.trySpinIfEnoughMoneyElseEmitNotEnough();
				}
			}
		} else {
			if (this.module.validateSpinPress()) {
				this.trySpinIfEnoughMoneyElseEmitNotEnough();
			}
		}
	}

	protected trySpinIfEnoughMoneyElseEmitNotEnough(): void {
		if (this._isTryingToRunSpinBySpaceButton) {
			this.emit(SpinButtonEvents.SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED);
		}
		if (this.module.userHasEnougMoneyToSpin()) {
			this.tryToStartSpin();

			this.view.spinButtonClickAction();
			this.module.setSpinStarted();
		} else {
			this.emit(SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY);
		}
	}

	protected tryToStartSpin(): void {
		if (this.module.canSpin) {
			// all the _logic goes here
			this.view.disableSpinButton();

			if (this.module.userHasEnougMoneyToSpin()) {
				this.emit(SpinButtonEvents.PRE_SPIN_BUTTON_PRESSED);
				this.emit(SpinButtonEvents.SPIN_BUTTON_PRESSED);

				this.view.spinButtonClickAction();
				this.module.canSpin = false;
			} else {
				this.emit(SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY);
			}
		}
	}

	protected onCanSpin(): void {
		if (!this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
			this.view.enableSpinButton();
			this.module.canSpin = true;
		}
	}

	protected onReelsSpinStarted(): void {
		this._isTryingToRunSpinBySpaceButton = false;

		if (this.module.hasSpinTimeRegulation()) {
			this.module.regulationCanSpin = false;
			this.module.startRegulationSpinTimer();
		}
		this.module.gotoState(SpinButtonModule.REELS_SPINNING_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/states/SpinButtonBasicState.ts